export default "__VITE_ASSET__95555714__"